module.exports = import("https://cdn.jsdelivr.net/npm/fuse.js@7.1.0/dist/fuse.mjs");;